import React from "react";
function Marquee (){
    return(
        <>
                {/* <!-- Marquee --> */}
        <div className="tf-marquee bg_yellow-2">
            <div className="wrap-marquee">
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
                <div className="marquee-item">
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="15" height="20" viewBox="0 0 15 20"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path></svg>
                    </div>
                    <p className="text">Spring Clearance Event: Save Up to 70%</p>
                </div>
            </div>
                      
        </div>
        {/* <!-- /Marquee --> */}

        </>

    )
}
export default Marquee;